import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ResultsListComponent} from '@shared/results-list/results-list.component';
import {BaseService} from '@shared/services/base.service';

@Component({
    selector: 'app-notification-modal',
    imports: [CommonModule, ResultsListComponent],
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss']
})
export class NotificationModalComponent implements OnInit {
  service: BaseService;
  searchObj: any;
  globalid: any;
  constructor(public http: HttpClient, public m: NgbActiveModal) { }

  ngOnInit(): void {
    this.searchObj = {search: this.globalid};
    this.service = new BaseService(`${environment.baseUrl}/onestop/permits/contacts/`, this.http);
  }

}
